import { OrderedListOutlined, UserOutlined } from '@ant-design/icons'
import {
  BranchesListListData,
  branchesListListInfiniteOptions,
  Dropdown,
  PaginatedDropdownList,
  SourcesListListData,
  sourcesListListInfiniteOptions,
  UsersListListData,
  usersListListInfiniteOptions
} from '@crm/api'
import { RangePickerFilter } from '@crm/components'
import { InfiniteSelect } from '@crm/components'
import { ReportSelect } from '@crm/features/reports/components'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { Flex } from 'antd'

export const ReportSalesFunnelFilter = () => {
  const { t } = useLocales()
  const { params, updateQuery } = useQueryUpdate()

  return (
    <Flex align="center" gap={10}>
      <ReportSelect />

      <InfiniteSelect<SourcesListListData, PaginatedDropdownList, Dropdown>
        getQueryFunction={sourcesListListInfiniteOptions}
        placeholder={t('filter.source')}
        value={params.lead_source && parseInt(params.lead_source)}
        onChange={(lead_source) => updateQuery({ lead_source })}
        suffixIcon={<OrderedListOutlined />}
        className="select-min-width"
      />

      <InfiniteSelect<UsersListListData, PaginatedDropdownList, Dropdown>
        getQueryFunction={usersListListInfiniteOptions}
        placeholder={t('filter.agent')}
        value={params.owner && parseInt(params.owner)}
        onChange={(owner) => updateQuery({ owner })}
        suffixIcon={<UserOutlined />}
        className="select-min-width"
      />

      <InfiniteSelect<BranchesListListData, PaginatedDropdownList, Dropdown>
        getQueryFunction={branchesListListInfiniteOptions}
        placeholder={t('filter.branch')}
        value={params.branch && parseInt(params.branch)}
        onChange={(branch) => updateQuery({ branch })}
        suffixIcon={<OrderedListOutlined />}
        className="select-min-width"
      />

      <RangePickerFilter
        fromParam="date_from"
        toParam="date_to"
        placeholder={[t('filter.date_from'), t('filter.date_to')]}
      />
    </Flex>
  )
}
